import Layout from "../../layout/Layout";

const PrivacyPolicies = () => {
    return (
        <Layout>
            <div
                className="w-100 px-3 p_spaced"
                style={{ backgroundImage: "url(/assets/pages/contact/bg_contact.jpg)", backgroundSize: "contain" }}
            >
                <div className="container">
                    <div className="bg-white p-5">
                        <div className="side side_top mb-3">
                            <h2>wcar politica de tratamiento de datos app</h2>
                        </div>
                        <p>
                            WCAR S.A.S. identificada con NIT- 901566049-8 y con domicilio en Bogotá en la Calle 98a #
                            69B-35 (“WCAR”) es una entidad comprometida con la protección de la privacidad y de toda
                            información que pueda asociarse o relacionarse con personas naturales y jurídicas,
                            determinadas o determinables (los “Datos Personales”), a la cual tenga acceso en el
                            desarrollo de sus actividades y funciones. WCAR recibe, recolecta, utiliza, administra,
                            analiza, segmenta, indexa, transmite, transfiere, almacena y, en general, procesa Datos
                            Personales tales como los de identificación (nombre, cédula, edad, género), de contacto
                            (teléfono, correo electrónico, dirección), o de información financiera, entre otros,
                            información que podrá ser obtenida en el curso y para el desarrollo de sus actividades y
                            funciones.
                        </p>
                        <p>
                            Sus datos personales son importantes y serán tratados con base en los principios que
                            establece la Ley 1581 de 2012 y se utilizarán solamente para las finalidades señaladas a
                            continuación.
                        </p>
                        <div className="side mb-3">
                            <h4>ÁMBITO DE APLICACIÓN</h4>
                        </div>
                        <p>
                            La presente Política de Tratamiento de la Información de WCAR (la “Política”) está dirigida
                            a: usuarios y potenciales usuarios que utilicen la aplicación WCAR y página web wcar.co y
                            que de cualquier manera estén relacionados y/o involucrados con los servicios prestados por
                            WCAR, y que tienen que ver con tu automóvil o modo de transporte, a cualquier persona cuyos
                            Datos Personales estén siendo o vayan a ser tratados por WCAR (los “Titulares”). La Política
                            tiene como propósito describir los mecanismos y procedimientos para proteger los derechos de
                            los Titulares; identificar al área que atenderá las consultas, preguntas, reclamos y quejas,
                            y, finalmente, describir las finalidades y los tipos de Tratamiento (según se define más
                            adelante) a los cuales se someterán los Datos Personales. Esta Política se aplicará a todo
                            Tratamiento realizado dentro del territorio de la República de Colombia por WCAR y, en lo
                            que corresponda, con aquellos terceros con los que WCAR acuerde todo o parte de la
                            realización de cualquier actividad relacionada con el Tratamiento de Datos Personales
                            respecto de los cuales WCAR actúa como Responsable (según se define más adelante).
                        </p>
                        <div className="side  mb-3">
                            <h4>DEFINICIONES</h4>
                        </div>
                        <p>
                            Las expresiones que estén entre paréntesis, subrayadas y escritas con mayúsculas iniciales
                            en esta Política tendrán el significado que se les otorga antes de los paréntesis. Los
                            términos no definidos tendrán el significado que la ley o la jurisprudencia aplicable en
                            Colombia les otorgue. A continuación, se definen los términos más relevantes de esta
                            Política:
                        </p>
                        <ul>
                            <li>
                                <strong>Autorización:</strong> Consentimiento previo, expreso e informado del Titular
                                para llevar a cabo el Tratamiento de Datos Personales.
                            </li>
                            <li>
                                <strong>Autorizado:</strong> Hace referencia a WCAR y a todas las personas bajo la
                                responsabilidad de WCAR que en virtud de la Autorización y de esta Política, tienen
                                legitimidad para realizar el Tratamiento.
                            </li>
                            <li>
                                <strong>Base de Datos:</strong> Conjunto de Datos Personales que sea objeto de
                                Tratamiento, electrónico o no, cualquiera que fuere la modalidad de su formación,
                                almacenamiento, organización y acceso. WCAR mantendrá de manera separada las Bases de
                                Datos en las que tenga la calidad de Encargado, de aquellas en las que tenga la
                                condición de Responsable.
                            </li>
                            <li>
                                <strong>Dato Personal:</strong> Es la información de cualquier tipo, vinculada o que
                                pueda asociarse a una o varias personas naturales determinadas o determinables, como lo
                                pueden ser datos de identificación (nombre, cédula, edad, género), de contacto
                                (teléfono, correo electrónico, dirección), información financiera y otros datos.
                            </li>
                            <li>
                                <strong>Dato Público:</strong> Dato Personal calificado como tal, según los mandatos de
                                la ley o de la Constitución Política y aquel que no sea semiprivado, privado o sensible.
                                Son considerados datos públicos, entre otros, los datos relativos al estado civil de las
                                personas, a su profesión u oficio y a su calidad de comerciante o de servidor público y
                                aquellos que puedan obtenerse sin reserva alguna. Por su naturaleza, los datos públicos
                                pueden estar contenidos, entre otros, en registros públicos, documentos públicos,
                                gacetas y boletines oficiales y sentencias judiciales debidamente ejecutoriadas que no
                                estén sometidas a reserva.
                            </li>
                            <li>
                                <strong>Datos Sensibles:</strong> Es el Dato Personal que podría afectar la intimidad
                                del Titular o cuyo uso indebido puede generar su discriminación, tales como aquellos que
                                revelen el origen racial o étnico, la orientación política, las convicciones religiosas
                                o filosóficas, la pertenencia a sindicatos, organizaciones sociales, de derechos humanos
                                o que promueva intereses de cualquier partido político o que garanticen los derechos y
                                garantías de partidos políticos de posición, así como los datos relativos a la salud, a
                                la vida sexual, y los datos biométricos.
                            </li>
                            <li>
                                <strong>Encargado del Tratamiento:</strong> Persona natural o jurídica, pública o
                                privada, que por sí misma o en asocio con otros, realice el Tratamiento de Datos
                                Personales por cuenta del Responsable del Tratamiento.
                            </li>
                            <li>
                                <strong>Legitimado:</strong> Son aquellas personas que pueden ejercer los derechos del
                                Titular, tales como el mismo Titular, sus causahabientes, representantes, apoderados y
                                aquellos que, por estipulación a favor de otro o para otro, estén acreditados, siempre
                                que puedan acreditar su condición.
                            </li>
                            <li>
                                <strong>Ley:</strong> Hace referencia a: la Ley 1581 de 2012, el Decreto 1074 de 2015,
                                la Sentencia C-748 de 2011, la jurisprudencia aplicable de la Corte Constitucional y a
                                la regulación relacionada expedida por el gobierno.
                            </li>
                            <li>
                                <strong>Manual:</strong> Es el documento en el cual están consignadas las políticas y
                                procedimientos para asegurar el cumplimiento de la Ley.
                            </li>
                            <li>
                                <strong>Responsable del Tratamiento:</strong> Persona natural o jurídica, pública o
                                privada, que por sí misma o en asocio con otros, decida sobre la Base de Datos y/o el
                                Tratamiento de los Datos Personales. En el presente documento, el Responsable del
                                tratamiento será WCAR.
                            </li>
                            <li>
                                <strong>Titular:</strong> Es la persona natural a quien se refieren los Datos
                                Personales, cuya información podrá reposar en una Base de Datos y quien es el sujeto del
                                derecho de hábeas data.
                            </li>
                            <li>
                                <strong>Transferencia:</strong> Es el Tratamiento que implica el envío de la información
                                o de los Datos Personales a un receptor, que es Responsable y se podrá encontrar fuera o
                                dentro del territorio de la República de Colombia. En la Transferencia el receptor
                                actuará en calidad de Responsable y no estará sujeto a los términos y condiciones de
                                esta Política.
                            </li>
                            <li>
                                <strong>Tratamiento:</strong> Es toda operación o procedimiento sistemático, electrónico
                                o no, incluso a través de herramientas como web bugs, cookies, spiders, web crawlers y
                                web beacons, que permita la recolección, conservación, ordenamiento, almacenamiento,
                                modificación, indexación, perfileo, relacionamiento, uso, circulación, análisis,
                                segmentación, anonimización, compendio, evaluación, bloqueo, destrucción y, en general,
                                el procesamiento de Datos Personales, así como también su entrega a terceros a través de
                                comunicaciones, consultas, interconexiones, cesiones, mensajes de datos y otros medios
                                que sirvan al efecto.
                            </li>
                        </ul>
                        <div className="side  mb-3">
                            <h4>PRINCIPIOS</h4>
                        </div>
                        <p>
                            En todo Tratamiento realizado por WCAR los Encargados y/o terceros a quienes se les
                            Transmitan Datos Personales, se les dará cumplimiento integral de los principios
                            establecidos en la Ley y los a continuación enunciados:
                        </p>
                        <ul>
                            <li>
                                <strong>Principio de legalidad en materia de Tratamiento de datos:</strong> El
                                Tratamiento a que se refiere el presente manual es una actividad reglada que debe
                                sujetarse a lo establecido en la Ley 1581 de 2012 y en las demás disposiciones que la
                                desarrollen.
                            </li>
                            <li>
                                <strong>Principio de finalidad:</strong> Toda actividad de Tratamiento debe ser
                                consistente con las finalidades legítimas mencionadas en esta Política, finalidades que
                                deben ser informadas al Titular al momento de obtener su autorización.
                            </li>
                            <li>
                                <strong>Principio de libertad:</strong> El Tratamiento sólo puede ejercerse con la
                                Autorización, previa, expresa e informada del Titular. Los Datos Personales no podrán
                                ser obtenidos o divulgados sin previa autorización, o en ausencia de mandato legal o
                                judicial que releve el consentimiento.
                            </li>
                            <li>
                                <strong>Principio de veracidad o calidad:</strong> El Dato Personal sometido a
                                Tratamiento debe corresponder a la información suministrada por los Titulares y ser
                                completo, exacto, actualizado, comprobable y comprensible. WCAR aplicará esfuerzos
                                razonables para evitar someter a Tratamiento Datos Personales parciales, incompletos,
                                fraccionados o que induzcan a error y para mantener la integridad de los Datos
                                Personales que estén contenidos en sus Bases de Datos y la veracidad de los mismos.
                            </li>
                            <li>
                                <strong>Principio de transparencia:</strong> Cuando el Titular lo solicite, WCAR le dará
                                acceso a los Datos Personales solicitados. La respuesta a la solicitud será enviada por
                                correo electrónico y dentro de los términos establecidos por la Ley.
                            </li>
                            <li>
                                <strong>Principio de acceso y circulación restringida:</strong> WCAR no podrá hacer
                                disponibles Datos Personales para su acceso a través de Internet u otros medios de
                                comunicación, a menos que se establezcan medidas técnicas y de seguridad que permitan
                                controlar el acceso y restringirlo solo a las personas autorizadas. Los Datos Personales
                                sólo pueden ser Tratados por aquel personal de WCAR que cuente con autorización para
                                ello de acuerdo con lo establecido por el presente documento, o quienes dentro de sus
                                funciones tengan a cargo la realización de tales actividades. No podrán entregarse Datos
                                Personales a terceros, dentro o fuera del territorio de la República de Colombia, sin la
                                Autorización o sin la suscripción de un contrato, en caso de que haya Transmisión.
                            </li>
                            <li>
                                <strong>Principio de seguridad:</strong> Para realizar el Tratamiento, WCAR debe
                                disponer de las medidas técnicas, humanas y de seguridad necesarias para mantener la
                                confidencialidad y seguridad razonables de los Datos Personales. Lo anterior con el fin
                                de evitar que los Datos Personales sean adulterados, modificados, consultados, usados,
                                accedidos, eliminados o conocidos por terceros no Autorizados. WCAR ajustará el
                                Tratamiento de Datos Personales a los estándares de seguridad que las autoridades
                                competentes reglamenten en un futuro.
                            </li>
                            <li>
                                <strong>Principio de confidencialidad:</strong> El Tratamiento deberá someterse a
                                requisitos de confidencialidad y, por tanto, las personas que intervengan en el mismo,
                                deberán mantener la reserva de la información, incluso después de que se haya terminado
                                el vínculo que dio origen al Tratamiento.
                            </li>
                            <li>
                                <strong>Tratamiento de Datos Sensibles y Diligencia:</strong> Los Datos Sensibles que se
                                recolecten en las actividades de WCAR, deberán ser Tratados con diligencia para
                                preservar su integridad, incluyendo acceso restringido y seguridad.
                            </li>
                            <li>
                                <strong>Temporalidad:</strong> WCAR no usará los Datos Personales más allá del plazo
                                razonable que exija la finalidad que fue divulgada al respectivo Titular. WCAR también
                                aplicará medidas tendientes a asegurar la supresión de los Datos Personales cuando estos
                                dejen de cumplir la finalidad para la cual fueron recolectados.
                            </li>
                        </ul>
                        <div className="side  mb-3">
                            <h4>DATOS QUE SE UTILIZARÁN</h4>
                        </div>
                        <ul>
                            <li>
                                <strong>Datos personales:</strong> Para llevar a cabo las finalidades descritas en el
                                presente aviso, al ingresar a la aplicación o a la página web wcar.co, WCAR utilizará
                                los siguientes datos personales (de los cuales el usuario y/o visitante es Titular) o
                                los que estén relacionados con los servicios prestados por WCAR en relación con el/los
                                automóviles o modo(s) de transporte, que utiliza: Identificación (tipo y número)
                                Dirección, nombre completo, correo electrónico, edad, género, teléfono fijo o teléfono
                                celular
                            </li>
                            <li>
                                <strong>Datos de su vehículo(s):</strong> marca, modelo, color, año, kilometraje, fecha
                                de matrícula, fecha vencimiento SOAT, fecha vencimiento Revisión Tecnomecánica,
                                fotocopia tarjeta de propiedad, póliza de seguro todo riesgo.
                            </li>
                            <li>
                                <strong>
                                    Hábitos y tendencias de consumo de los usuarios, preferencias de marcas, etc.
                                </strong>
                            </li>
                            <li>
                                <strong>IMPORTANTE:</strong> WCAR no recopila Datos Personales sensibles al utilizar los
                                Medios Electrónicos.
                            </li>
                        </ul>
                        <div className="side mb-3">
                            <h4>DERECHOS DE LOS TITULARES</h4>
                        </div>
                        <p>De acuerdo con la Ley, los Titulares tienen los siguientes derechos:</p>
                        <ul>
                            <li>
                                <strong>Actualización:</strong> Actualizar los Datos Personales que reposen en las Bases
                                de Datos de WCAR para mantener su integridad y veracidad.
                            </li>
                            <li>
                                <strong>Conocimiento y Acceso:</strong> Conocer y acceder a sus Datos Personales
                                almacenados por WCAR o los Encargados. Este acceso se permitirá de forma gratuita según
                                solicitud al menos una vez al mes.
                            </li>
                            <li>
                                <strong>Prueba:</strong> Solicitar prueba de la Autorización otorgada a WCAR, salvo que
                                la Ley indique que dicha Autorización no es necesaria o que la misma haya sido validada
                                con arreglo a lo establecido en el artículo 10 del Decreto 1377 (artículo 2.2.2.25.2.7
                                del Decreto 1074 de 2015).
                            </li>
                            <li>
                                <strong>Queja:</strong> Presentar ante la Superintendencia de Industria y Comercio
                                quejas por infracciones a la Ley cuando se haya agotado el requisito de procedibilidad y
                                acudir en primera instancia a WCAR.
                            </li>
                            <li>
                                <strong>Rectificación:</strong> Rectificar la información y los Datos Personales que
                                estén bajo el control de WCAR.
                            </li>
                            <li>
                                <strong>Revocación:</strong> Solicitar la revocatoria de la Autorización, siempre y
                                cuando no exista un deber legal o una obligación de carácter contractual con WCAR.
                            </li>
                            <li>
                                <strong>Solicitud:</strong> Presentar solicitudes ante WCAR o el Encargado respecto del
                                uso que les han dado a sus Datos Personales.
                            </li>
                            <li>
                                <strong>Solicitar la supresión:</strong> de sus Datos Personales de las Bases de Datos
                                de WCAR, siempre y cuando no exista un deber legal o una obligación de carácter
                                contractual en cabeza del Titular con WCAR, según la cual el Titular no tenga el derecho
                                de solicitar la supresión de sus Datos Personales.
                            </li>
                        </ul>
                        <div className="side  mb-3">
                            <h4>PERIODO DE ALMACENAMIENTO DE DATOS PERSONALES</h4>
                        </div>
                        <p>
                            WCAR SAS, mantendrán los datos personales del Titular mientras éste tenga una cuenta en la
                            aplicación móvil denominada “WCAR”.
                        </p>
                        <div className="side  mb-3">
                            <h4>AUTORIZACIONES Y AVISOS</h4>
                        </div>
                        <p>
                            Todo Tratamiento debe estar precedido por la obtención de la Autorización. Para ello, WCAR,
                            sus empleados y Autorizados, previo a la recolección de los Datos Personales, deberán
                            obtener la Autorización suscrita por el Titular y conservar una copia de este documento para
                            consultas futuras. WCAR, en su condición de Responsable, ha dispuesto de los mecanismos
                            necesarios para obtener la Autorización de los Titulares garantizando en todo caso que sea
                            posible verificar el otorgamiento de dicha Autorización. La Autorización puede constar en un
                            documento físico, electrónico, grabación de la voz o cualquier otro formato que permita
                            garantizar su posterior consulta, o mediante un mecanismo técnico o tecnológico idóneo
                            mediante el cual se pueda concluir de manera inequívoca, que, de no haberse surtido una
                            conducta del Titular, los Datos Personales nunca hubieren sido capturados y almacenados en
                            la Base de Datos. La autorización del Titular no será necesaria cuando se trate de:
                        </p>
                        <ul>
                            <li>
                                Información requerida por una entidad pública o administrativa en ejercicio de sus
                                funciones legales o por orden judiciales.
                            </li>
                            <li>Datos de naturaleza pública.</li>
                            <li>Casos de urgencia médica o sanitaria.</li>
                            <li>
                                Tratamiento de información autorizado por la ley para fines históricos, estadísticos o
                                científicos.
                            </li>
                            <li>Datos relacionados con el Registro Civil de las Personas.</li>
                        </ul>
                        <p>
                            WCAR podrá obtener la Autorización para el Tratamiento de Datos Personales, mediante
                            diferentes medios, entre ellos electrónico, mensaje de datos, internet, sitios web, o en
                            cualquier otro formato que en todo caso permita la obtención del consentimiento mediante
                            conductas inequívocas, a través de las cuales se concluya sin lugar a dudas que de no
                            haberse surtido la misma por parte del Titular o la persona legitimada para ello, los Datos
                            Personales no se hubieran almacenado o recolectado en la Base de Datos. Dicha Autorización
                            será solicitada por WCAR.
                        </p>
                        <div className="side mb-3">
                            <h4>ATENCIÓN DE PETICIONES, CONSULTAS Y RECLAMOS</h4>
                        </div>
                        <p>
                            El Área de Servicio al Cliente es la dependencia que tiene a cargo dar trámite a las
                            solicitudes de los titulares para hacer efectivos sus derechos. Las peticiones, consultas y
                            reclamos pueden ser enviadas al correo electrónico: contacto@wcar.co o través del número de
                            contacto +57 301 8063302. PROCEDIMIENTO PARA EL EJERCICIO DEL DERECHO DE PROTECCIÓN DE DATOS
                            PERSONALES En cumplimiento de las normas sobre protección de datos personales, WCAR SAS,
                            presenta el procedimiento y requisitos mínimos para el ejercicio de sus derechos: Para la
                            radicación y atención de su solicitud le solicitamos suministrar la siguiente información:
                        </p>
                        <ul>
                            <li>Nombre completo y apellidos.</li>
                            <li>Datos de contacto (Dirección electrónica y teléfonos de contacto).</li>
                            <li>Medios para recibir respuesta a su solicitud.</li>
                            <li>
                                Motivo(s)/hecho(s) que dan lugar al reclamo con una breve descripción del derecho que
                                desea ejercer (conocer, actualizar, rectificar, solicitar prueba de la autorización
                                otorgada, revocarla, suprimir, acceder a la información).
                            </li>
                            <li>Firma (si aplica) y número de identificación.</li>
                        </ul>
                        <p>
                            El término máximo previsto por la ley para resolver su reclamación es de quince (15) días
                            hábiles, contado a partir del día siguiente a la fecha de su recibo. Cuando no fuere posible
                            atender el reclamo dentro de dicho término, WCAR S.A.S, informará al interesado los motivos
                            de la demora y la fecha en que se atenderá́su reclamo, la cual en ningún caso podrá superar
                            los ocho (8) días hábiles siguientes al vencimiento del primer término. Una vez cumplidos
                            los términos señalados por la Ley 1581 de 2012 y las demás normas que la reglamenten o
                            complementen, el Titular al que se deniegue, total o parcialmente, el ejercicio de los
                            derechos de acceso, actualización, rectificación, supresión y revocación podrá poner su caso
                            en conocimiento de la Superintendencia de Industria y Comercio –Delegatura para la
                            Protección de Datos Personales
                        </p>
                        <ul>
                            <li>
                                <strong>Declaración de Propiedad y Afiliación:</strong> La aplicación móvil WCAR es
                                propiedad y está operada por WCAR SAS. La Empresa es una entidad privada y no está
                                afiliada ni representada por ninguna entidad gubernamental.
                            </li>
                            <li>
                                <strong>Renuncia de Responsabilidad:</strong> La información proporcionada en la
                                Aplicación se ofrece con fines informativos únicamente y no debe considerarse como
                                asesoramiento legal o profesional. La Empresa no garantiza la precisión, integridad o
                                puntualidad de la información proporcionada en la Aplicación.
                                <br />
                                <br />
                                El uso de la Aplicación es bajo su propio riesgo y responsabilidad. La Empresa y sus
                                afiliados no se hacen responsables de ninguna pérdida o daño que pueda derivarse de su
                                uso, incluyendo, pero no limitándose a, daños directos, indirectos, incidentales,
                                consecuenciales o especiales.
                            </li>
                        </ul>
                        <div className="side mb-3">
                            <h4>FINALIDADES PERSONALES DEL TRATAMIENTO DE DATOS</h4>
                        </div>
                        <p>
                            WCAR, en el curso de sus actividades comerciales, Tratará los Datos Personales.Dichos Datos
                            Personales deberán someterse únicamente a las finalidades que se señalan a continuación o
                            las que sean aceptadas por los Titulares en el momento de la recolección de los Datos
                            Personales. Asimismo, los Encargados o terceros que tengan acceso a los Datos Personales en
                            virtud de la Ley, contrato u otro documento vinculante, realizarán el Tratamiento para la
                            consecución de las siguientes finalidades:
                        </p>
                        <ul>
                            <li>
                                Adelantar la gestión administrativa que WCAR requiera respecto de sus clientes, aliados,
                                proveedores, empleados y demás grupos de interés.
                            </li>
                            <li>Proporcionar una valoración preliminar e informativa sobre los vehículos.</li>
                            <li>
                                Programar citas presenciales para llevar a cabo: una valoración del (los) vehículo(s),
                                seguimiento a la compra o venta del (los) vehículo(s), entre otros.
                            </li>
                            <li>
                                Desarrollar estudios internos sobre los intereses de los Titulares, con el objetivo de
                                comprender mejor las necesidades e intereses de los Titulares, para brindar un mejor
                                servicio.
                            </li>
                            <li>
                                Enviar correspondencia, correos electrónicos, contactar telefónicamente o por cualquier
                                medio disponible a los Titulares, en desarrollo de actividades publicitarias,
                                promocionales y de mercadeo enfocados a su actividad
                            </li>
                            <li>
                                Compartirlos o enviarlos a terceros con quienes WCAR realice alianzas o celebre
                                contratos, para fines comerciales relacionados con la ejecución de las actividades
                                comprendidas dentro de su objeto social.
                            </li>
                            <li>
                                Asegurar la calidad de nuestros servicios, así como la seguridad de las transacciones
                                realizadas con los vehículos de nuestros clientes.
                            </li>
                        </ul>
                        <div className="side  mb-3">
                            <h4>COMPARTIR INFORMACIÓN CON TERCEROS</h4>
                        </div>
                        <p>WCAR comparte sus Datos Personales en los siguientes casos:</p>
                        <ul>
                            <li>A autoridades que requieren la misma en términos de legislación aplicable</li>
                            <li>
                                A autoridades que la soliciten como parte de un proceso judicial o administrativo donde
                                sea necesario revelar la información
                            </li>
                            <li>
                                A herramientas contratadas por WCAR para comunicación y marketing con sus consumidores y
                                para llevar a cabo labores de tercerización de servicios
                            </li>
                            <li>Transferencias y Transmisiones con terceros</li>
                            <li>Los demás casos previstos en la Ley</li>
                        </ul>
                        <div className="side  mb-3">
                            <h4>CONFIDENCIALIDAD Y MEDIDAS DE SEGURIDAD </h4>
                        </div>
                        <p>
                            Para WCAR la confidencialidad y protección de los Datos Personales es una prioridad, por lo
                            que la empresa ha establecido y conservado medidas de seguridad administrativas, técnicas y
                            físicas para evitar el daño, pérdida, alteración, destrucción, así como el uso, acceso o
                            divulgación indebida. Adicionalmente, y en cumplimiento al principio de seguridad
                            establecido en la Ley, WCAR ha adoptado y adoptará las medidas técnicas, tecnológicas,
                            humanas y administrativas que sean del caso para otorgar seguridad a los registros
                            salvaguardando su confidencialidad, integridad y disponibilidad.
                        </p>
                        <div className="side  mb-3">
                            <h4>PROCEDIMIENTOS PARA EJERCER LOS DERECHOS DE LOS TITULARES</h4>
                        </div>
                        <p>
                            <strong>Consultas:</strong> WCAR recibirá y resolverá las consultas del Titular, Legitimados
                            o los representantes de menores de edad relativas a:
                        </p>
                        <ul>
                            <li>
                                ¿Cuáles son los Datos Personales del Titular que se encuentran en las Bases de Datos de
                                WCAR?
                            </li>
                            <li>¿Cuál es el Tratamiento al cual están sujetos los Datos Personales?</li>
                            <li>¿Cuáles son las finalidades que pretenden satisfacer?</li>
                        </ul>
                        <p>
                            Tales consultas deberán ser enviadas por escrito a la siguiente dirección de correo
                            electrónico: contacto@wcar.co
                        </p>
                        <p>
                            WCAR guardará prueba de la consulta y de la respuesta. La consulta será atendida en un
                            término máximo de diez (10) días hábiles contados a partir de la fecha de recibo de la
                            misma. En caso de que no fuere posible atender la consulta dentro de dicho término, se
                            informará al interesado, expresando los motivos de la demora y señalando la fecha en que se
                            atenderá la consulta, la cual en ningún caso podrá superar los diez (10) días hábiles
                            siguientes al vencimiento del primer término.
                        </p>
                        <p>
                            <strong>Reclamos:</strong> WCAR recibirá y resolverá reclamos formulados por el Titular, los
                            Legitimados o los representantes de menores de edad respecto de:
                        </p>
                        <ul>
                            <li>
                                Datos Personales Tratados por WCAR que deben ser objeto de corrección, actualización o
                                supresión.
                            </li>
                            <li>El presunto incumplimiento de cualquiera de las obligaciones de WCAR según la Ley</li>
                        </ul>
                        <p>
                            Tales reclamos deberán ser enviados por escrito a la siguiente dirección de correo
                            electrónico: contacto@wcar.co.
                        </p>
                        <p>WCAR guardará prueba del reclamo y su respuesta.</p>
                        <p>
                            <strong>Recepción de Solicitudes:</strong> Estará en cabeza del área de operaciones recibir
                            las solicitudes de información. Esta se encargará de recibir las solicitudes de los
                            Titulares, para el ejercicio de los derechos de acceso, consulta, rectificación,
                            actualización, supresión y revocatoria a que se refiere la Ley 1581 de 2012. A nivel
                            interno, se han establecido procedimientos para la oportuna y eficaz atención de las
                            consultas y reclamos teniendo en cuenta los responsables de las diferentes bases de datos.
                        </p>
                        <p>
                            <strong>Cancelación de cuenta:</strong> En cumplimiento de las normas sobre protección de
                            datos personales, el Titular podrá eliminar a voluntad sus datos y su cuenta de la
                            aplicación yendo a la sección de perfil y dando clic en la opción “Eliminar cuenta”.
                        </p>
                        <div className="side  mb-3 ">
                            <h4>PUBLICIDAD Y MODIFICACIONES DE LA POLÍTICA</h4>
                        </div>
                        <p>
                            Esta Política podrá ser modificada por WCAR y hará parte de los contratos que celebre WCAR,
                            donde resulte pertinente. Toda modificación sustancial de esta Política tendrá que ser
                            comunicada previamente a los Titulares por medio de mecanismos eficientes, tales como la
                            página web y la aplicación de WCAR wcar.co y/o correos electrónicos.
                        </p>
                        <p>Por modificación sustancial se entienden, entre otras, las siguientes situaciones:</p>
                        <ul>
                            <li>
                                Modificación en la identificación del área, dependencia o persona encargada de atender
                                las consultas y reclamos
                            </li>
                            <li>
                                Modificación evidente de las finalidades que puedan afectar la Autorización. En este
                                caso WCAR obtendrá una nueva Autorización.
                            </li>
                        </ul>
                        <p>
                            Las modificaciones serán informadas en la página web de WCAR y/o mediante un correo
                            electrónico que será enviado a los Titulares, siempre y cuando WCAR tenga esa información en
                            su poder.
                        </p>
                        <div className="side mb-3">
                            <h4>VIGENCIA DE LA POLÍTICA Y DE LAS DE BASES DE DATOS.</h4>
                        </div>
                        <p>
                            Esta Política empezará a regir a partir del primero (1) de enero de dos mil veinticuatro
                            (2024). Los Datos Personales que sean almacenados, utilizados o transmitidos permanecerán en
                            la Base de Datos de WCAR con base en el criterio de temporalidad, durante el tiempo que sea
                            necesario para las cumplir con las finalidades mencionadas en esta Política, para las cuales
                            fueron recolectados. De este modo, la vigencia de la Base de Datos está estrechamente
                            relacionada con las finalidades para las cuales fueron recolectados los Datos Personales.
                        </p>
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default PrivacyPolicies;
